import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "reportWebVitals";
import { Provider } from "react-redux";
import { store } from "app/store";
import { CssBaseline, responsiveFontSizes, ThemeProvider } from "@mui/material";
import theme from "theme";
import App from "components/App";
import ErrorHandler from "components/error-handler/error-handler";
import OperationErrorHandler from "components/error-handler/operation-error-handler";

/**
 * Initializes React component structure to the web page
 */
ReactDOM.render(
  <React.StrictMode>
    <Provider store={ store }>
      <ThemeProvider theme={ responsiveFontSizes(theme) }>
        <CssBaseline/>
        <ErrorHandler>
          <OperationErrorHandler>
            <App/>
          </OperationErrorHandler>
        </ErrorHandler>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();